export default __webpack_public_path__ + "static/media/feature-lowfee-home.6c00ff5e.svg";